
<template>
  <div class="wrap-black">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6 signup-content xs-mb-50 md-mb-50">
          <h1>Sign Up <br/>For Free</h1>
          <p>
            CLEX is aware that the cost of post secondary education is very expensive, and in order to make your life as stress free as possible,
            we are giving you CLEX for free at no charge, with no obligation to purchase for as long as you need it. No three month trial like most service providers.
          </p>
          <router-link :to="{name: 'features'}" class="btn-pub btn-pub-blank fixed-width">Learn More</router-link>
        </div>
        <div class="col-xs-12 col-sm-6 signup-form-wrap">
          <div class="signup-form">
            <p>Please enter your information to sign up for CLEX, for free!</p>
            <div v-if="currentUser.errors" v-for="msg in currentUser.errors" role="alert" class="alert alert-contrast alert-danger alert-dismissible">
              <div class="message">{{msg}}</div>
            </div>
            <form method="post" v-on:submit.prevent="register" class="form-pub">
              <div class="row">
                <div class="col-xs-12 col-sm-6 form-group">
                  <input autofocus v-model="newUser.first_name" name="first_name" class="form-control" type="text" placeholder="Your First Name" autocomplete="off" required="required">
                </div>
                <div class="col-xs-12 col-sm-6 form-group">
                  <input v-model="newUser.last_name" name="last_name" class="form-control" type="text" placeholder="Your Last Name" autocomplete="off" required="required">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xs-12">
                  <input v-model="newUser.email" name="email" class="form-control" type="email" placeholder="Your E-mail" autocomplete="off" required="required">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xs-12">
                  <input v-model="newUser.password" name="password" class="form-control" type="password" placeholder="Password" autocomplete="off" required="required">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xs-12">
                  <input v-model="newUser.password_confirmation" name="password_confirmation" class="form-control" type="password" placeholder="Re-enter Password" autocomplete="off" required="required">
                </div>
              </div>

              <div class="alert alert-success" v-if="currentUser.showSuccess">We've sent you an email with a confirmation link. Please check your emails for instructions.</div>

              <div class="form-group xs-pt-10 row">
                <div class="col-xs-12 col-md-6">
                  <button class="btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width">Sign Up</button>
                </div>
                <div class="col-xs-12 col-md-6">
                  <router-link to="/login" class="login-link">Have an account? <strong>Log in</strong>.</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex'

export default {

  created() {
    this.$store.commit(`CLEAR_USER_ERRORS`);
  },

  //{"email": "bob@example.com", "password": "password", "password\_confirmation": "password"}
  methods: {
    register() {
      this.$store.commit(`CLEAR_USER_ERRORS`);
      this.$store.dispatch('register', this.newUser)
    },
  },

  computed: {
    ...mapState([
      'currentUser',
    ])
  },

  data() {
    return {
      newUser: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        password_confirmation: null,
      }
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .signup-content h1 {font-size:50px;margin-bottom:20px;}
  .signup-content p {font-size:18px;margin-bottom:30px;max-width:400px;}

  .signup-form p {font-size:18px;margin-bottom:30px;}
  .signup-form .login-link {color:#FFFFFF;font-size:16px;display:inline-block;margin-top:35px;text-align:right;}

  @media (max-width: 767px) {
    .wrap-black {padding:0px;}
    .signup-form-wrap { margin-left: -20px; background: #FFFFFF; width: calc(100% + 40px); }
      .signup-form-wrap .signup-form { padding:40px 20px;}
      .signup-form-wrap .signup-form p {color:#222222;text-align:center;}
    .signup-content {padding:20px;}
    .signup-form .login-link { color: #4285f4; }
  }
</style>



// WEBPACK FOOTER //
// Signup.vue?63d7430c